/// <reference path="../_all.ts" />

module shoppinglist {
  'use strict';
  
  var escape = new RegExp('[\\-\\[\\]\\/\\{\\}\\(\\)\\*\\+\\?\\.\\\\\^\\$\\|]', 'g');

  export interface IOfNumber extends ng.IFilterService {
      (name: 'ofnumber'): (amount, maxFraction) => string;
  }
  
  OfNumber.$inject = ['$filter', '$locale'];
  export function OfNumber($filter, $locale) {


    var number = $filter('number'), formats = $locale.NUMBER_FORMATS;
    return function (amount : number, maxFraction : number) {
        var value = number(amount, maxFraction);
        value = value.replace(/0+$/, '');
        return value.replace(new RegExp('\\' + formats.DECIMAL_SEP + '$'), '');
    }  
        
  }
}


